import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _estimationTargetLabe;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable  @typescript-eslint/no-explicit-any */
import { ca } from '@cian/analytics';
import { EEstimationTargets } from '../types';
import { caEventCategories } from '../constants/caEventCategories';
export var estimationTargetLabels = (_estimationTargetLabe = {}, _defineProperty(_estimationTargetLabe, EEstimationTargets.flat, 'flat'), _defineProperty(_estimationTargetLabe, EEstimationTargets.newbuilding, 'JK'), _estimationTargetLabe);
export function trackEstimationTargetSelect(estimationTarget) {
  ca('eventSite', {
    name: 'oldevent',
    category: caEventCategories[estimationTarget],
    action: 'SelectEstimateType',
    label: estimationTargetLabels[estimationTarget]
  });
}
export function trackAddressChange(value, estimationTarget) {
  ca('eventSite', {
    name: 'oldevent',
    category: caEventCategories[estimationTarget],
    action: 'ChangeAddress',
    label: value
  });
}
export function prepareTrackAddressPick(page) {
  return function (rawAddress, suggestedAddress, estimationTarget) {
    ca('eventSite', {
      name: 'oldevent',
      category: caEventCategories[estimationTarget],
      action: 'TypeIn',
      label: 'FullAddress',
      page: _objectSpread(_objectSpread({}, page), {}, {
        extra: {
          rawAddress: rawAddress,
          suggestedAddress: suggestedAddress
        }
      })
    });
  };
}
export function trackAddressInputClick(estimationTarget) {
  ca('eventSite', {
    name: 'oldevent',
    category: caEventCategories[estimationTarget],
    action: 'Click',
    label: 'Address'
  });
}
export function trackAddressInputLaterSomeSeconds(label, estimationTarget) {
  ca('eventSite', {
    name: 'oldevent',
    category: caEventCategories[estimationTarget],
    action: 'InputTimeout',
    label: label
  });
}
export function trackAreaPick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'TypeIn',
    label: 'Area'
  });
}
export function trackRoomsCountClick(estimationTarget) {
  ca('eventSite', {
    name: 'oldevent',
    category: caEventCategories[estimationTarget],
    action: 'Click',
    label: 'RoomsNumber'
  });
}